import { FC } from 'react';
import { joinStrings } from '../../../utils/string';

type ItvViewAllGridProps = {
  title?: string;
  tiles: (JSX.Element | null)[];
  backBtnTitle?: string;
  isOneRowMobile?: boolean;
  onBack: () => void;
};

export const ItvViewAllGrid: FC<ItvViewAllGridProps> = ({
  title,
  tiles,
  backBtnTitle = 'Back to Lobby',
  isOneRowMobile,
  onBack,
}) => (
  <div className="itv-view-all">
    <div className="itv-view-all__header">
      <h1 className="itv-view-all__title">{title}</h1>
      <p className="itv-view-all__back-text" onClick={onBack} aria-label="Back to lobby">
        {backBtnTitle}
      </p>
    </div>

    <div className={joinStrings(['itv-view-all__grid', isOneRowMobile && 'itv-view-all__grid--one-row'])}>{tiles}</div>
  </div>
);
